import React from 'react';

import {
  ContentLayerV2,
  LayerWrapper,
  ShimLayer,
  styled,
} from '@vw-marketing/us-components';

const LayerZIndex = styled.div`
  z-index: 10;

  & [class^='StyledHeaderContainer-'],
  & [class*=' StyledHeaderContainer-'] {
    background-color: ${({ theme }) => theme.colors.background.primary};
  }
`;

interface LayerProps {
  active: boolean;
  headline?: string;
  closeButtonLabel: string;
  onClick: () => void;
  onClose: () => void;
  children: React.ReactNode;
}
export const Layer = ({
  active,
  headline = '',
  closeButtonLabel,
  onClick,
  onClose,
  children,
}: LayerProps) => {
  return (
    <LayerZIndex>
      <LayerWrapper>
        {active ? (
          <>
            <ShimLayer key="shim" onClick={onClick} />
            <ContentLayerV2
              key="content-layer-v2"
              active={active}
              contentHeadline={headline}
              closeButtonLabel={closeButtonLabel}
              onClose={onClose}
            >
              {children}
            </ContentLayerV2>
          </>
        ) : undefined}
      </LayerWrapper>
    </LayerZIndex>
  );
};
